// extracted by mini-css-extract-plugin
export var container = "style-module--container--DVIuu";
export var entryHeadline = "style-module--entryHeadline--uZaZ9";
export var icon = "style-module--icon--jeX51";
export var iconActive = "style-module--iconActive--r6-OH";
export var isAccordion = "style-module--isAccordion--kVLWn";
export var isActive = "style-module--isActive--R1-iY";
export var item = "style-module--item--qKAPC";
export var text = "style-module--text--Sc5sA";